import { ComponentProps, ReactNode } from 'react';
import clsx from 'clsx';

import styles from './StepItem.module.css';

interface StepItemProps extends Omit<ComponentProps<'div'>, 'title' | 'content'> {
  title: ReactNode;
  content: ReactNode;
  footer?: ReactNode;
  image: ReactNode;
  stepNumber: number;
}

export default function StepItem({ title, content, footer, image, stepNumber, className, ...props }: StepItemProps) {
  return (
    <div
      className={clsx(styles.step, className)}
      {...props}
    >
      <div className={styles.main}>
        <span className={clsx(styles.number, styles.desktopNumber)}>{stepNumber}</span>
        <h3 className={styles.title}>{title}</h3>
        <div className={styles.content}>{content}</div>
        {footer && <div className={styles.footer}>{footer}</div>}
      </div>
      <div className={styles.image}>{image}</div>
      <span className={clsx(styles.number, styles.mobileNumber)}>{stepNumber}</span>
    </div>
  );
}
